import { useEffect } from "react";
import Button from "../../../shared/components/Button";
import { Flex } from "../../../shared/components/Flex";
import type { Camera } from "../model";

export function CameraFocusModal({
  camera,
  onClose,
}: {
  camera: Camera;
  onClose: () => void;
}) {
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [onClose]);

  return (
    <div
      aria-labelledby="camera-focus-title"
      aria-modal="true"
      className="focus-backdrop"
      onClick={onClose}
      role="dialog"
    >
      <div className="focus-panel" onClick={(event) => event.stopPropagation()}>
        <header className="focus-header">
          <div>
            <p className="eyebrow">Live camera</p>
            <h2 id="camera-focus-title">{camera.location}</h2>
            <p>
              {camera.id} · {camera.protocol?.toUpperCase() ?? "Unknown"} feed
            </p>
          </div>
          <Button
            aria-label="Close fullscreen camera"
            className="close"
            onClick={onClose}
            variant="ghost"
          >
            ×
          </Button>
        </header>
        <div className="focus-media" style={{ backgroundColor: camera.accent }}>
          {camera.streamURL ? (
            <img alt={`Live feed from ${camera.location}`} src={camera.streamURL} />
          ) : (
            <span>Stream unavailable</span>
          )}
        </div>
        <Flex className="focus-details" wrap="wrap">
          <span className={`focus-status focus-status--${camera.status.toLowerCase()}`}>
            {camera.status}
          </span>
          <span>Last seen {camera.lastSeen}</span>
          <span>Resolution 1080p</span>
        </Flex>
      </div>
    </div>
  );
}
